import { Box, Paper, Typography } from '@mui/material'
import React, { useState } from 'react'

import { IQueryFilter } from '../../type'
import CorrectionHistoryTable from './CorrectionHistoryTable'
import DataCorrectionForms from './DataCorrectionForms'
import InformationDisplay from './InformationDisplay'

interface IAiBlackboxProps {
  startDate?: string
  endDate?: string
  queryFilter: IQueryFilter | null
}

const ManualDataCorrection: React.FC<IAiBlackboxProps> = ({
  startDate = '',
  queryFilter,
}) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const handleDataSubmitted = () => {
    // Trigger refresh of history table
    setRefreshTrigger((prev) => prev + 1)
  }

  return (
    <Box sx={{ p: 2 }}>
      {/* Section 1: Information display */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <InformationDisplay startDate={startDate} queryFilter={queryFilter} />

        {/* Section 2: Forms */}
        <Box sx={{ mt: 3 }}>
          <DataCorrectionForms
            startDate={startDate}
            queryFilter={queryFilter}
            onDataSubmitted={handleDataSubmitted}
          />
        </Box>
      </Paper>

      {/* Section 3: History table */}
      <Paper sx={{ p: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Lexend-SemiBold',
            fontSize: '1rem',
            mb: 2,
          }}
        >
          Manual Correction History (Latest 30 Days)
        </Typography>
        <CorrectionHistoryTable refreshTrigger={refreshTrigger} />
      </Paper>
    </Box>
  )
}

export default ManualDataCorrection
